import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { DynamicScriptLoaderServiceService } from '../../_services/dynamic-script-loader-service.service';
import { AuthenicationService } from '../../_services/authenication.service';
import { PatientsService } from '../../_services/patients.service';
import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-patientappointments',
  templateUrl: './patientappointments.component.html',
  styleUrls: ['./patientappointments.component.css']
})
export class PatientappointmentsComponent implements OnInit {

  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  id: string = this.route.snapshot.params.id;
  returnUrl: string;
  appointments: [];

  // tslint:disable-next-line:max-line-length
  constructor(private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private patientsService: PatientsService, private toaster: ToasterService) { }


  ngOnInit() {
    // DynamicScriptLoaderServiceService.adminScripts();
    // DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/custom.js');
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }

    // console.log(payload);
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
    const payload = {
      clientid: this.id
    };
    this.getPatientAppointment(payload);
  }


  getPatientAppointment(docid) {
    this.patientsService.getPatientAppointment(docid)
      .subscribe (
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Appointments', data.ResponseMessage);
            this.appointments = data.ClientAppointment;
            // console.log(this.appointments);
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('Appointments', data.ResponseMessage);
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Doctor', error.error.ResponseMessage);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }


}
